<template>
  <div>
    <v-data-table
      :items="shownUsers"
      :headers="headers"
      :loading="loading"
      hide-default-footer
      density="compact"
      class="data-table"
    >
      <template #loader="{ isActive }">
        <v-progress-linear :active="isActive" indeterminate color="primary" />
      </template>
      <template v-slot:item="{ item }">
        <tr @click="rowCLick(item)" @contextmenu="show($event, item)">
          <td>
            <DataTableTextCell :value="item.name" />
          </td>
          <td>
            <DataTableTextCell :value="item.surname" />
          </td>
          <td>
            <DataTableTextCell :value="item.email" />
          </td>
          <td>
            <DataTableDropdownCell
              :model-value="item.role"
              @update:model-value="
                (value) => {
                  inputChange({ item, header: 'role', value })
                }
              "
              :edit-mode="canEditItem(item)"
              :class="[getDirtyClass(item, 'role')]"
              :items="roles"
            />
          </td>
        </tr>
      </template>
    </v-data-table>

    <TableActionMenu
      @update:show-menu="showMenu = $event"
      :selected-item="selectedItem"
      :show-menu="showMenu"
      :x="x"
      :y="y"
      :add-button="false"
      @action="clickDelete(selectedItem)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTableTextCell from '@/components/userManagement/DataTableTextCell.vue'
import DataTableDropdownCell from '@/components/userManagement/DataTableDropdownCell.vue'
import DirtyFieldsMixIn from '@/mixins/DirtyFieldsMixIn.vue'
import OptionsFieldsMixin from '@/mixins/OptionsFieldsMixin.vue'
import ShowActionMenuMixin from '@/mixins/ShowActionMenuMixin.vue'
import TableActionMenu from '@/components/common/TableActionMenu.vue'

export default {
  name: 'UserManagementTable',
  components: {
    TableActionMenu,
    DataTableDropdownCell,
    DataTableTextCell
  },
  computed: {
    ...mapState('userManagement', {
      shownUsers: (state) => state.items,
      loading: (state) => state.loading,
      storeDirtyItems: (state) => state.dirtyItems
    }),
    ...mapState('project', {
      currentProject: (state) => state.currentProject,
      isAdmin: (state) => state.currentProject.currentprojectuser.role === 'admin'
    }),
    ...mapState('users', {
      currentUser: (state) => state.currentUser
    })
  },
  mixins: [DirtyFieldsMixIn, OptionsFieldsMixin, ShowActionMenuMixin],
  data: () => ({
    headers: [
      { title: 'Name', key: 'name', width: '30%' },
      { title: 'Surname', key: 'surname', width: '30%' },
      { title: 'Email', key: 'email', width: '30%' },
      { title: 'Role', key: 'role', width: '10%' }
    ],
    roles: ['admin', 'contributor', 'viewer'],
    isEditMode: false,
    selectedUsers: []
  }),
  watch: {
    currentProject({ id }) {
      if (id) {
        this.fetchProjectUser(id)
      }
    }
  },
  methods: {
    ...mapActions('userManagement', {
      fetchProjectUser: 'fetchItems',
      resetState: 'resetState',
      setParameter: 'setParameter',
      emptyDirtyItems: 'emptyDirtyItems',
      searchUsers: 'searchUsers',
      addUsers: 'addUsers',
      updateRoles: 'updateRoles',
      deleteItem: 'deleteItem'
    }),
    rowCLick(item) {
      this.selectedItem = item
    },
    canEditItem(item) {
      return item && this.isAdmin && this.selectedItem === item && this.currentUser.id !== item.user
    },
    inputChange({ item, header, value }) {
      this.addDirty(item, header)
      this.setParameter({ item, value, parameter: header })
    },
    clearDirtyItems() {
      this.emptyDirtyItems()
      this.dirtyItems = []
    },
    async saveChanges() {
      // called from parent
      await this.updateRoles(
        this.storeDirtyItems.map(({ id, role, project, user }) => ({ id, role, project, user }))
      )
      this.clearDirtyItems()
    },
    async clickDelete({ id }) {
      await this.deleteItem(id)
    }
  },
  async mounted() {
    this.resetState()
    if (this.currentProject.id) {
      await this.fetchProjectUser(this.currentProject.id)
    }
  }
}
</script>

<style scoped>
.table-actions {
  margin-bottom: 25px;
}

.data-table:deep(th) {
  text-align: left;
  font-size: 0.75rem;
  font-family: Roboto, sans-serif;
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
